<template>
  <div class="notifications-wrapper">
    <div class="container">
      <div class="card">
        <h2>{{ $t("app.profil.notifications.title") }}</h2>
        <div class="card-section">
          <h4>{{ $t("app.profil.notifications.email") }}</h4>
          <p class="muted">
            {{ $t("app.profil.notifications.emailDesc") }}
          </p>
          <div class="toggle-container">
            <div class="input-wrapper input-wrapper-toggle inline" v-for="n in 3" :key="'email-' + n">
              <div class="toggle">
                <input type="checkbox" />
                <label></label>
              </div>
              <div class="content">
                <p class="bold">{{ $t("app.profil.notifications.sampleTitle") }}</p>
                <p class="muted">{{ $t("app.profil.notifications.sampleDesc") }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="card-section">
          <h4>{{ $t("app.profil.notifications.sms") }}</h4>
          <p class="muted">
            {{ $t("app.profil.notifications.smsDesc") }}
          </p>
          <div class="toggle-container">
            <div class="input-wrapper input-wrapper-toggle inline" v-for="n in 3" :key="'sms-' + n">
              <div class="toggle">
                <input type="checkbox" />
                <label></label>
              </div>
              <div class="content">
                <p class="bold">{{ $t("app.profil.notifications.sampleTitle") }}</p>
                <p class="muted">{{ $t("app.profil.notifications.sampleDesc") }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="card-section">
          <h4>{{ $t("app.profil.notifications.saas") }}</h4>
          <p class="muted">
            {{ $t("app.profil.notifications.saasDesc") }}
          </p>
          <div class="toggle-container">
            <div class="input-wrapper input-wrapper-toggle inline" v-for="n in 3" :key="'saas-' + n">
              <div class="toggle">
                <input type="checkbox" />
                <label></label>
              </div>
              <div class="content">
                <p class="bold">{{ $t("app.profil.notifications.sampleTitle") }}</p>
                <p class="muted">{{ $t("app.profil.notifications.sampleDesc") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
